import lity from 'lity';

(function($) {
    var _this = {
        'current_region': [],
        'home_region': [],
        'target_region': [],
        'popup': [],
        'body': $('body'),
        'popup_settings': {
            'template': '<div class="lity" role="dialog" tabindex="-1"><div class="lity-wrap" role="document"><div class="lity-loader" aria-hidden="true">Loading...</div><div class="lity-container"><div class="lity-content"></div></div></div></div>',
            'esc': false,
        },


        // Function to call to setup region popups & cookies
        setup: function() {
            var container = $('.j-region-menu');
            _this.setupHomeRegion(container);
            _this.setupCurrentRegion(container);

            // Check if the current region is the home region
            _this.checkCurrentRegion();
            _this.hooks();
        },
        // Hooks for watching actions
        hooks: function() {
            $('.j-region--link').on('click', function(e) {
                e.preventDefault();
                var linkObj = $(this);
                _this.handleRegionLink(linkObj);
            });
            _this.body.on('click', '.j-region--leave', function(e) {
                e.preventDefault();

                _this.confirmRegionChange();
            });
            _this.body.on('click', '.j-region--stay', function(e) {
                e.preventDefault();
                _this.confirmOutOfRegionStay();
            });
            _this.body.on('click', '.j-region--current-stay', function(e) {
                e.preventDefault();
                _this.confirmCurrentRegionStay();
            });
        },


        /**********
         * REGION SETUP
         ********/

        // setup the home region for inspection
        setupHomeRegion: function(linkObj) {
            _this.home_region = {
                'id': linkObj.data('home_region_id'),
                'link': linkObj.data('home_region_link'),
                'geocode': linkObj.data('home_region_geocode'),
                'defaultCode': linkObj.data('home_region_defaultcode'),
                'currentRegionPopup': linkObj.data('current_region_popup'),
            };
            console.log(_this.home_region);
            // set popup for home region return
            $('.j-home-region--link').attr('href', _this.home_region.link);
        },
        // setup the target region for inspection
        setupCurrentRegion: function(linkObj) {
            _this.current_region = {
                'id': linkObj.data('current_region_id'),
                'link': linkObj.data('current_region_link'),
                'allowed': linkObj.data('current_region_allowed'),
            };
        },
        // setup the target region for inspection
        setupTargetRegion: function(linkObj) {
            _this.target_region = {
                'id': linkObj.data('region_id'),
                'link': linkObj.data('region_link'),
            };
        },


        /**********
         * ACTIONS
         ********/

        // Check if the current region is the home region
        checkCurrentRegion: function() {
            console.log("Home Region ID: " + _this.home_region.id);
            console.log("Current Region ID: " + _this.current_region.id);

            // If the current region is the home region return
            if (_this.current_region.id === _this.home_region.id) {
                // if its the home region display the current region popup
                _this.getCurrentRegionStayConfirmation();
                return;
            }
            // If the current region has been allowed (cookie set) return
            if (_this.current_region.allowed) {
                return;
            }
            // If the current region is not the home region and has not been allowed get confirmation to stay
            _this.getOutOfRegionStayConfirmation();
        },
        // Handle when a Region Link is clicked
        handleRegionLink: function(linkObj) {
            _this.setupTargetRegion(linkObj);
            _this.processRegionLink();
        },
        // Process when a Region Link is clicked
        processRegionLink: function() {
            // if you are trying to go to your home region, allow it
            if (_this.target_region.id === _this.home_region.id) {
                window.location.href = _this.target_region.link;
                return;
            }
            // If you are trying to go to a different region give popup
            if (_this.target_region.id !== _this.home_region.id) {
                _this.getRegionChangeConfirmation();
            }
        },


        /**********
         * POPUPS
         ********/

        // Region Change Confirmation
        getRegionChangeConfirmation: function() {
            _this.popup = lity('#region-redirect', _this.popup_settings);
        },

        // Region Change Confirmation
        getOutOfRegionStayConfirmation: function() {
            _this.popup = lity('#region-welcome', _this.popup_settings);
        },
        // Region Change Confirmation
        getCurrentRegionStayConfirmation: function() {
            // Only display the popup if it is set
            if (_this.home_region.currentRegionPopup) {
                _this.popup = lity('#region-current', _this.popup_settings);
            }
        },


        /**********
         * CONFIRMATION ACTIONS
         ********/

        // Handles when confirmation is giving to change regions
        confirmRegionChange: function() {
            // Set allow region cookie (no popup) and redirect
            _this.setCookie(_this.target_region.id);
            _this.goToRegion(_this.target_region.link);
        },

        // Handles when confirmation is giving to stay on an out of region - region
        confirmOutOfRegionStay: function() {
            // Set allow region cookie and close popup
            _this.setCookie(_this.current_region.id);
            _this.popup.close();
        },
        // Handles when confirmation is giving to stay on an out of region - region
        confirmCurrentRegionStay: function() {
            // Set allow region cookie and close popup

            _this.createCookie("current_region_popup__" + _this.current_region.id, 1);
            _this.popup.close();
        },


        /**********
         * HELPER FUNCTIONS
         ********/


        // Redirects to given url
        goToRegion: function(url) {
            window.location.href = url;
        },
        // Set cookie
        setCookie: function(region_id) {
            _this.createCookie("allow_region__" + region_id, 1);
        },
        createCookie: function(name, value, days) {
            // Cookie setter function
            var expires = "";
            if (days) {
                var date = new Date();
                date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
                expires = "; expires=" + date.toGMTString();
            } else {
                expires = "";
            }
            document.cookie = name + "=" + value + expires + "; path=/";
        }
    };
    // Attach Toolbox to window
    window.regions = _this;
})(jQuery); // Fully reference jQuery after this point.
